<div class="cb-textarea-wrapper" [class.cb-disabled]="disabled()" [class.cb-required]="required()">
    @if(label() || info()){
    <div class="cb-textarea-label">
        @if(label()){
        <label>{{label()}}</label>
        }
        @if(info() && info()!.length>0){
        <cb-icon [cbTooltip]="info()!" tooltipPosition="top" tooltipStyle="dark" name="cb-base-outline-help"></cb-icon>
        }
    </div>
    }
    <div class="cb-textarea-container">
        <div class="cb-textarea">
            <textarea #Textarea [rows]="rows()" [maxRows]="maxRows() ?? 0" [maxLength]="maxLength()"
                [autosize]="autosize() ?? false" [(ngModel)]="value" [disabled]="disabled()"
                [placeholder]="placeholder() ?? ''"></textarea>
        </div>
    </div>
    @if(hint() && hint()!.length>0){
    <p class="cb-textarea-hint">{{hint()}}</p>
    }
</div>